import DeleteSvg from '../../../assets/delete.svg?react';
import { IconProps } from '../../types/IconProps';

export function Delete({ size = 20, ...props }: IconProps) {
  return <DeleteSvg data-testid="delete-icon" width={size} height={size} {...props} />;
}

export default Delete;
